module.exports = __webpack_public_path__ + "static/media/botanicalGinkgo.99d8a211.jpg";